// src/components/Footer.js

import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

const Footer = () => {
  const paypalLink =
    "https://www.paypal.com/donate/?hosted_button_id=JWCTWZHY89WV2";

  // A simple function to scroll to the top of the page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behaviour: "smooth",
    });
  };

  return (
    <footer className="site-footer">
      <Container>
        <Row>
          {/* Column 1: Brand and Mission */}
          <Col lg={5} md={12} className="mb-4 mb-lg-0">
            <img
              src={logo}
              alt="Aussie Wildlife Limited Logo"
              className="footer-logo mb-3"
            />
            <p className="text-muted">
              A community-driven conservation organisation dedicated to the
              ethical rehabilitation and sustainable care of Australia’s unique
              wildlife.
            </p>
            <Button
              variant="secondary"
              href={paypalLink}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2"
            >
              Support Our Mission
            </Button>
          </Col>

          {/* Column 2: Navigation Links */}
          <Col lg={3} md={6} className="mb-4 mb-lg-0">
            <h5 className="footer-heading">Navigate</h5>
            <ul className="list-unstyled footer-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/what-we-do">What We Do</Link>
              </li>
              <li>
                <Link to="/team">The Team</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </Col>

          {/* Column 3: Contact and Social */}
          <Col lg={4} md={6} className="mb-4 mb-lg-0">
            <h5 className="footer-heading">Get In Touch</h5>
            <ul className="list-unstyled footer-contact">
              <li>
                <i className="fas fa-map-marker-alt me-2"></i>Gold Coast, QLD,
                Australia
              </li>
              <li>
                <i className="fas fa-envelope me-2"></i>
                <a href="mailto:jen@aussiewildlife.org.au">
                  jen@aussiewildlife.org.au
                </a>
              </li>
            </ul>
            <h5 className="footer-heading mt-4">Follow Us</h5>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/AussieWildlife1"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="social-icon"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://www.instagram.com/aussiewildlife_limited"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="social-icon"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/aussie-wildlife-limited/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="social-icon"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </Col>
        </Row>

        <hr className="footer-divider" />

        {/* Sub-Footer: Copyright and Back to Top */}
        <Row className="footer-bottom-bar align-items-center">
          <Col md={6}>
            <p className="mb-0">
              © {new Date().getFullYear()} Aussie Wildlife Limited. All Rights
              Reserved.
            </p>
          </Col>
          <Col md={6} className="text-md-end">
            <a
              href="#top"
              onClick={(e) => {
                e.preventDefault();
                scrollToTop();
              }}
              className="back-to-top"
            >
              Back to Top <i className="fas fa-arrow-up"></i>
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
